[
    {
        "id": 1753432075780,
        "first_name": "Bhargav",
        "middle_name": "Anand",
        "last_name": "Bondarde",
        "dob": "2025-07-23",
        "gender": "Male",
        "blood_group": {
            "blood_group": "O+",
            "value": "O+"
        },
        "primary_contact": "9370165548",
        "secondary_contact": null,
        "email": "bhargav@gmail.com",
        "aadhar_number": "45456456456456",
        "password": "customer@123",
        "pan_number": "45654drAD5",
        "street_line_1": null,
        "street_line_2": null,
        "street_line_3": null,
        "landmark": null,
        "country": {
            "country": "India",
            "value": "India"
        },
        "state": "Andhra Pradesh",
        "city": "Pune",
        "pin_code": "411048",
        "nationality": "Indian",
        "special_needs": null,
        "emergency_contact_name": "Bhargav Bondarde",
        "emergency_contact_number": "9370165548",
        "emergency_contact_address": "Pune",
        "emergency_contact_relation": {
            "emergency_contact_relation": "Parent",
            "value": "Parent"
        },
        "passport_number": "66556asd49as1654",
        "passport_issue_date": "2025-07-17",
        "passport_expiry_date": "2025-07-25",
        "passport_issue_country": {
            "name": "India",
            "value": "India"
        },
        "passport_status": {
            "passport_status": "Active",
            "value": "Active"
        },
        "tags": null,
        "notes": null,
        "customer_type": {
            "customer_type": "individual"
        },
        "isActive": 1,
        "createdBy": "1",
        "createdAt": 1753294294323,
        "updatedBy": null,
        "updatedAt": null,
        "deletedBy": null,
        "deletedAt": null,
        "deletedReason": null
    }
]